import type { CustomIconProps } from '../CustomIcon';
import { ArrowUpIcon } from './ArrowUpIcon';

export const ArrowDownIcon = (props: CustomIconProps) => (
  <ArrowUpIcon style={{ transform: 'rotate(180deg)' }} {...props} />
);
